var React = require('react');

function IconUnfold (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M859.4 514.1L565.3 220c-3.9-3.9-3.9-10.2 0-14.1l36-36c3.9-3.9 10.2-3.9 14.1 0L952.6 507c3.9 3.9 3.9 10.2 0 14.1L615.4 858.4c-3.9 3.9-10.2 3.9-14.1 0l-36-36c-3.9-3.9-3.9-10.2 0-14.1l294.1-294.2zM365.6 514.1L71.4 220c-3.9-3.9-3.9-10.2 0-14.1l36-36c3.9-3.9 10.2-3.9 14.1 0L458.7 507c3.9 3.9 3.9 10.2 0 14.1L121.5 858.4c-3.9 3.9-10.2 3.9-14.1 0l-36-36c-3.9-3.9-3.9-10.2 0-14.1l294.2-294.2z"}));
}

IconUnfold.displayName = "IconUnfold";

IconUnfold.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconUnfold;

IconUnfold.default = IconUnfold;
